import type { LucideIcon } from "lucide-react-native";
import {
  Scissors,
  FlaskConical,
  Zap,
  Syringe,
  Shield,
  Pill,
  Target,
  Radio,
  MoreHorizontal,
} from "lucide-react-native";

// ── Cancer treatment types ──────────────────────────────

export type CancerTreatmentType =
  | "surgery"
  | "chemotherapy"
  | "radiation_therapy"
  | "bone_marrow_transplant"
  | "immunotherapy"
  | "hormone_therapy"
  | "targeted_drug_therapy"
  | "radiofrequency_therapy"
  | "other";

export interface CancerTreatmentOption {
  id: CancerTreatmentType;
  labelKey: string;
  icon: LucideIcon;
}

const TREATMENT_LABEL_KEY = (id: CancerTreatmentType): string =>
  `med_history.medical.disease_history.cancer_treatments.treatment_types.${id}`;

export const CANCER_TREATMENT_OPTIONS: CancerTreatmentOption[] = [
  { id: "surgery", labelKey: TREATMENT_LABEL_KEY("surgery"), icon: Scissors },
  {
    id: "chemotherapy",
    labelKey: TREATMENT_LABEL_KEY("chemotherapy"),
    icon: FlaskConical,
  },
  {
    id: "radiation_therapy",
    labelKey: TREATMENT_LABEL_KEY("radiation_therapy"),
    icon: Zap,
  },
  {
    id: "bone_marrow_transplant",
    labelKey: TREATMENT_LABEL_KEY("bone_marrow_transplant"),
    icon: Syringe,
  },
  {
    id: "immunotherapy",
    labelKey: TREATMENT_LABEL_KEY("immunotherapy"),
    icon: Shield,
  },
  {
    id: "hormone_therapy",
    labelKey: TREATMENT_LABEL_KEY("hormone_therapy"),
    icon: Pill,
  },
  {
    id: "targeted_drug_therapy",
    labelKey: TREATMENT_LABEL_KEY("targeted_drug_therapy"),
    icon: Target,
  },
  {
    id: "radiofrequency_therapy",
    labelKey: TREATMENT_LABEL_KEY("radiofrequency_therapy"),
    icon: Radio,
  },
  { id: "other", labelKey: TREATMENT_LABEL_KEY("other"), icon: MoreHorizontal },
];

export function getCancerTreatmentLabelKey(treatmentType: string): string {
  return (
    CANCER_TREATMENT_OPTIONS.find((o) => o.id === treatmentType)?.labelKey ??
    TREATMENT_LABEL_KEY("other")
  );
}
